import React, { useState } from "react";
import { Modal as AntModal, Button, message, Space } from "antd";
import styled from "styled-components";
import { api } from "@api";
import { IconCheckLight } from "../../../../assets/icons";
import { Trans, useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-close-icon svg {
    font-size: 24px;
  }

  .ant-modal-title {
    color: #1e1e1e;
    font-size: 24px;
    font-weight: 700;
  }

  .ant-modal-body {
    font-size: 16px;
    font-weight: 400;
    color: #1d1014;
  }

  .ant-modal-footer {
    .ant-btn {
      width: 100%;
      height: 56px;
    }

  

    .ant-space {
      width: 100%;
      gap: 16px !important;

      .ant-space-item {
        flex: 1;
      }
    }
  }
`;

const RefundConfirmModal = ({ id, open, handleClose, successCallback, refundAmount, currencyName }) => {
  const [loading, setLoading] = useState(false);

  const {t} = useTranslation();
  
  const handleReject = () => {
    if (!loading) {
      setLoading(true);
      api
        .refundOrderRequest(id)
        .then(() => {
          setLoading(false);
          message.success(t('refund_success'));
          handleClose();
          successCallback();
        })
        .catch((error) => {
          setLoading(false);
          message.error(error);
        });
    }
  };

  const onCancel = () => {
    !loading && handleClose();
  };

  return (
    <Modal
      centered
      width={500}
      open={open}
      onCancel={onCancel}
     title={
        <span style={{ fontSize: 18, fontWeight: 700 }}>
          <Trans
            i18nKey="refund_order_amount"
            components={{ br: <br /> }}
          />
          {" ("}
          {Number(refundAmount).toLocaleString()} MMK
          {")"}
        </span>
      }
      footer={
        <Space>
          <Button type="default" onClick={onCancel}>
            {t('cancel')}
          </Button>
          <Button
            type="primary"
            icon={<IconCheckLight />}
            onClick={handleReject}
            loading={loading}
          >
            {t('confirm')}
          </Button>
        </Space>
      }
    >
      {t('can_not_undo')}
    </Modal>
  );
};

export default RefundConfirmModal;
